import React, { FC } from 'react';
import { Grid } from '@mui/material';
import { PnlCardSkeleton } from './pnl-card-skeleton';
import { WinLossRateCardSkeleton } from './win-loss-rate-card-skeleton';

export const CardsSectionSkeleton: FC = () => {
  return (
    <Grid
      size={{ xs: 12, sm: 6 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: { sm: '100%' },
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          flex: 1,
          height: '100%',
          alignContent: 'stretch',
        }}
      >
        {/* PnL Card */}
        <Grid size={{ xs: 12, sm: 6 }} sx={{ display: 'flex' }}>
          <PnlCardSkeleton />
        </Grid>

        {/* Win/Loss Rate Card */}
        <Grid size={{ xs: 12, sm: 6 }} sx={{ display: 'flex' }}>
          <WinLossRateCardSkeleton />
        </Grid>
      </Grid>
    </Grid>
  );
};
